import React from 'react';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={require('../img/firetv.png')} {...props} />
);

export default Badge;
